// extracted by mini-css-extract-plugin
export default {"reactions":"RyVTYX"};